var _circle, _g, _rect, _rect2, _path, _g2, _rect3, _path2, _path3, _rect4, _rect5, _rect6, _path4, _path5, _rect7, _rect8, _g3, _path6, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _g4, _g5, _path7, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _g6, _rect25, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfoIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 280,
    viewBox: "0 0 280 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 142,
    r: 120,
    fill: "#F3F6FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_35209_77807)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.2,
    y: 48,
    width: 229.6,
    height: 165.2,
    rx: 4,
    fill: "#AFBAC9"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 52,
    width: 222,
    height: 146,
    rx: 2,
    fill: "#F3F6FB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 85.3999,
    y: 241.2,
    width: 109.2,
    height: 2.8,
    rx: 1.4,
    fill: "#A0AFC3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.8 213.2C114.8 213.2 114.8 241.2 86.8 241.2H193.2C193.2 241.2 166.6 238.4 166.6 213.2H114.8Z",
    fill: "url(#paint0_linear_35209_77807)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_35209_77807)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-1_35209_77807",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109 65H227V198H109V65Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M109 65H227V198H109V65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 197.5H109V198.5H227V197.5Z",
    fill: "#AFBAC9",
    mask: "url(#path-6-inside-1_35209_77807)"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 65,
    width: 56,
    height: 133,
    fill: "#2E4890"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 54C29 52.8954 29.8954 52 31 52H249C250.105 52 251 52.8954 251 54V65H29V54Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 65H251V66H29V65Z",
    fill: "#AFBAC9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 88,
    width: 41,
    height: 8,
    rx: 2,
    fill: "#1A316E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 69,
    width: 28,
    height: 8,
    rx: 2,
    fill: "#407EDB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 69,
    width: 28,
    height: 8,
    rx: 2,
    fill: "#F3F6FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61 77C61 74.7909 62.7909 73 65 73H75V81H65C62.7909 81 61 79.2091 61 77Z",
    fill: "#407EDB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76 73H86C88.2091 73 90 74.7909 90 77C90 79.2091 88.2091 81 86 81H76V73Z",
    fill: "#407EDB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 102,
    width: 41,
    height: 8,
    rx: 2,
    fill: "#1A316E"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 116,
    width: 41,
    height: 8,
    rx: 2,
    fill: "#1A316E"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_35209_77807)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 86,
    width: 46,
    height: 105,
    rx: 4,
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M160.5 161.933L163.163 164.596L167.758 160",
    stroke: "#FF93B3",
    strokeWidth: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 123,
    y: 91,
    width: 36,
    height: 44,
    rx: 2,
    fill: "#F3F6FB"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 123,
    y: 138,
    width: 36,
    height: 6,
    rx: 2,
    fill: "#EEF1F6"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 123,
    y: 147,
    width: 36,
    height: 4,
    rx: 2,
    fill: "#F3F6FB"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 123,
    y: 154,
    width: 36,
    height: 4,
    rx: 2,
    fill: "#F3F6FB"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 123,
    y: 161,
    width: 36,
    height: 4,
    rx: 2,
    fill: "#FF93B3"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 123,
    y: 168,
    width: 36,
    height: 5,
    rx: 2,
    fill: "#F3F6FB"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 123,
    y: 175,
    width: 36,
    height: 5,
    rx: 2,
    fill: "#F3F6FB"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 123,
    y: 182,
    width: 36,
    height: 5,
    rx: 2,
    fill: "#F3F6FB"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 105.464,
    width: 8.65063,
    height: 22.1672,
    fill: "#4571B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.651 105.464L147.435 97.8945V120.062L143.651 127.631V105.464Z",
    fill: "#244469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.785 97.8945H147.435L143.651 105.464H135L138.785 97.8945Z",
    fill: "#5589D3"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_35209_77807)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 173,
    y: 86,
    width: 46,
    height: 105,
    rx: 4,
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M215.5 161.933L218.163 164.596L222.758 160",
    stroke: "#FF93B3",
    strokeWidth: 2
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 91,
    width: 36,
    height: 44,
    rx: 2,
    fill: "#F3F6FB"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 138,
    width: 36,
    height: 6,
    rx: 2,
    fill: "#EEF1F6"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 147,
    width: 36,
    height: 4,
    rx: 2,
    fill: "#F3F6FB"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 154,
    width: 36,
    height: 4,
    rx: 2,
    fill: "#F3F6FB"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 161,
    width: 36,
    height: 4,
    rx: 2,
    fill: "#FF93B3"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 168,
    width: 36,
    height: 5,
    rx: 2,
    fill: "#F3F6FB"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 175,
    width: 36,
    height: 5,
    rx: 2,
    fill: "#F3F6FB"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 182,
    width: 36,
    height: 5,
    rx: 2,
    fill: "#F3F6FB"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 105.464,
    width: 8.65063,
    height: 22.1672,
    fill: "#4571B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.651 105.464L202.435 97.8945V120.062L198.651 127.631V105.464Z",
    fill: "#244469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.785 97.8945H202.435L198.651 105.464H190L193.785 97.8945Z",
    fill: "#5589D3"
  }))), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 80,
    width: 118,
    height: 1,
    fill: "#F3F6FB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_35209_77807",
    x: 13.2,
    y: 40,
    width: 253.6,
    height: 189.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_35209_77807"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_35209_77807",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_35209_77807",
    x: 107,
    y: 63,
    width: 122,
    height: 137,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_35209_77807"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_35209_77807",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_35209_77807",
    x: 110,
    y: 80,
    width: 62,
    height: 121,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_35209_77807"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_35209_77807",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_35209_77807",
    x: 165,
    y: 80,
    width: 62,
    height: 121,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_35209_77807"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_35209_77807",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_35209_77807",
    x1: 140,
    y1: 213.2,
    x2: 140,
    y2: 241.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E9BAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E9F3"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon01);
export default __webpack_public_path__ + "static/media/info_icon01.0259d3143d0d892307edc854af1e9214.svg";
export { ForwardRef as ReactComponent };